import { isNotNil } from '../../../util/object';
import { createSelector } from 'reselect';

export const getDiscoverPublisher = (state) => {
  return isNotNil(state.discover) ? state.discover.discoverPublisher : null;
};

export const getIsPublisherOurStories = createSelector(
  [getDiscoverPublisher],
  (discoverPublisher) => {
    return isNotNil(discoverPublisher) && discoverPublisher.isOurStories;
  },
);

export const getIsPublisherDynamicEditions = createSelector(
  [getDiscoverPublisher],
  (discoverPublisher) => {
    return (
      isNotNil(discoverPublisher) && discoverPublisher.isDynamicEditionsPublisher
    );
  },
);

export const getIsPublisherHappeningNow = createSelector(
  [getDiscoverPublisher],
  (discoverPublisher) => {
    return (
      isNotNil(discoverPublisher) && discoverPublisher.isHappeningNowPublisher
    );
  },
);

export const getIsSingleAssetPublisher = createSelector(
  [getDiscoverPublisher],
  (discoverPublisher) => {
    return (
      isNotNil(discoverPublisher) && discoverPublisher.isSingleAssetPublisher()
    );
  },
);
